import { all, fork } from 'redux-saga/effects';
import appSaga from './onsiteSaga';
import customParamsSaga from './customParamsSaga';
import embeddedFormSaga from './embeddedFormSaga';

export default function* rootSaga() {
  yield all([
    fork(appSaga),
    fork(customParamsSaga),
    fork(embeddedFormSaga)
  ]);
}
